const defaultState = {
	search: '',
	searchStr: '',
	description: false,
	category: null,
	sort: '',
	clicked: false,
	filters: {},
	products: [],
	pagination: {
		page: 1,
		totalCount: 0,
		lastAvailablePage: 0,
	}
};


export const search = (state = defaultState, { type, data }) => {
	switch (type) {
		case 'SEARCH_ALL':
			return { ...state, ...data };
		case 'SEARCH':
			return { ...state, search: data };
		case 'SEARCH_DESC':
			return { ...state, description: !state.description };
		case 'SEARCH_CLICK':
			return { ...state, clicked: !state.clicked };
		case 'CHANGE_SORTING':
			return { ...state, sort: data }
		case 'CHANGE_FILTERS':
			return { ...state, filters: { ...state.filters, ...data } }
		case 'CHANGE_PRODUCTS':
			return { ...state, products: data }
		case 'CHANGE_PAGINATION':
			return { ...state, pagination: { ...state.pagination, ...data } }
		case 'RESET_DATA':
			return defaultState
		default:
			return state;
	}
}

export const resetData = () => {
	return dispatch => dispatch({
		type: 'RESET_DATA',
	})
}

export const searchAll = (string) => {
	return dispatch => dispatch({
		type: 'SEARCH_ALL',
		data: string
	})
};

export const changeSearch = (string) => {
	return dispatch => dispatch({
		type: 'SEARCH',
		data: string
	})
};

export const changeSort = (newSort) => {
	return dispatch => dispatch({
		type: 'CHANGE_SORTING',
		data: newSort
	})
}

export const changeFilters = (filters) => {
	return dispatch => dispatch({
		type: 'CHANGE_FILTERS',
		data: filters
	})
};

export const changePagination = (pagination) => {
	return dispatch => dispatch({
		type: 'CHANGE_PAGINATION',
		data: pagination
	})
}

export const changeProducts = (products) => {
	return dispatch => dispatch({
		type: 'CHANGE_PRODUCTS',
		data: products
	})
}

export const changeDESC = () => {
	return dispatch => dispatch({
		type: 'SEARCH_DESC',
		data: ''
	})
};

export const changeCLICK = () => {
	return dispatch => dispatch({
		type: 'SEARCH_CLICK',
		data: ''
	})
};